module.exports = __webpack_public_path__ + "media/images/veritrans_payment/Carrier_Au-ef0511048f1495cd8ec1bd13a8485f2e.jpg";